import AccountPropertiesTargetings from '@/api/admin/accountPropertiesTargetings.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      totalRecords: 0,
      searchTerm: '',
      currentPage: 1,
    },
  },
  getters: {
    allPropertiesAccountTargetings: state => state.table,
  },
  actions: {
    async getAccountPropertiesTargetings({ commit, state }) {
      // Prepare the filter parameters
      const skip = (state.table.currentPage - 1) * state.table.pageLength
      const filter = {
        skip,
        take: state.table.pageLength,
        searchTerm: state.table.searchTerm,
      }

      const properties = await AccountPropertiesTargetings.getLists(filter)
      commit('SET_PROPERTIES', properties.values)
      commit('SET_TOTALRECORDS', properties.totalCount)
    },
    async deleteProperty({ dispatch }, property) {
      // Call the service to delete the property
      await AccountPropertiesTargetings.deleteProperty(property)

      // Refetch the properties list
      await dispatch('getAccountPropertiesTargetings')
    },
  },
  mutations: {
    SET_PROPERTIES(state, properties) {
      state.table.rows = properties
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_CURRENT_PAGE(state, newPage) {
      state.table.currentPage = newPage
    },
  },
}
